(() => {
  const normalizeSimulator = (value) => value.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const isXPlane = (value) => /^x ?plane(?:\s|$)/.test(normalizeSimulator(value));
  const simulatorMatches = (productSimulator, chosenSimulator) => {
    const productValue = normalizeSimulator(productSimulator);
    const chosenValue = normalizeSimulator(chosenSimulator);
    return productValue === chosenValue || (isXPlane(productValue) && isXPlane(chosenValue));
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-sf-collection-controls]').forEach((toolbar) => {
      if (toolbar.dataset.initialized) return;
      const catalogue = toolbar.closest('.sf-collection-catalogue');
      const grid = catalogue?.querySelector('#product-grid');
      const productContainer = catalogue?.querySelector('#ProductGridContainer');
      const simulatorGroup = toolbar.querySelector('[data-sf-simulator-filter]');
      if (!grid || !simulatorGroup) return;
      toolbar.dataset.initialized = 'true';

      const mapButton = toolbar.querySelector('[data-sf-grid-view="map"]');
      const mapExplorer = mapButton ? document.querySelector('[data-sf-store-map][data-scope="airport"]') : null;
      const mapSection = mapExplorer?.closest('.shopify-section') || mapExplorer?.closest('section');
      if (mapButton && mapSection) mapSection.hidden = true;
      let lastProductView = 'grid';

      const items = [...grid.querySelectorAll(':scope > .grid__item')];
      const simulators = [...new Set(items.flatMap((item) =>
        (item.querySelector('[data-sf-simulators]')?.dataset.sfSimulators || '')
          .split('|').map((value) => value.trim()).filter(Boolean)
      ))].sort((a, b) => a.localeCompare(b));
      simulators.forEach((simulator) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sf-collection-simulator-button';
        button.dataset.simulatorValue = simulator.toLowerCase();
        button.setAttribute('aria-pressed', 'false');
        button.textContent = simulator;
        simulatorGroup.append(button);
      });

      const filterProducts = (chosen) => {
        items.forEach((item) => {
          const values = (item.querySelector('[data-sf-simulators]')?.dataset.sfSimulators || '')
            .split('|').map((value) => value.trim()).filter(Boolean);
          item.hidden = chosen !== 'all' && !values.some((value) => simulatorMatches(value, chosen));
        });
        simulatorGroup.querySelectorAll('[data-simulator-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.simulatorValue === chosen));
        });
        const count = catalogue.querySelector('.sf-collection-toolbar-count');
        const visibleCount = items.filter((item) => !item.hidden).length;
        if (count) {
          const noun = catalogue.dataset.sfSearchResults === 'true' ? (visibleCount === 1 ? 'result' : 'results') : (visibleCount === 1 ? 'product' : 'products');
          count.textContent = `${visibleCount} ${noun}${catalogue.dataset.sfSearchResults === 'true' ? ' on this page' : ''}`;
        }
      };

      simulatorGroup.addEventListener('click', (event) => {
        const button = event.target.closest('[data-simulator-value]');
        if (button) filterProducts(button.dataset.simulatorValue);
      });

      toolbar.querySelector('[data-sf-sort-control]')?.addEventListener('change', (event) => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', event.currentTarget.value);
        url.searchParams.delete('page');
        window.location.assign(url);
      });

      toolbar.querySelectorAll('[data-sf-grid-view]').forEach((button) => {
        button.addEventListener('click', () => {
          const view = button.dataset.sfGridView;
          if (view === 'map') {
            if (!mapSection || !productContainer) return;
            const showingMap = button.getAttribute('aria-pressed') !== 'true';
            mapSection.hidden = !showingMap;
            productContainer.hidden = showingMap;
            toolbar.querySelectorAll('[data-sf-grid-view]').forEach((control) => {
              control.setAttribute('aria-pressed', String(control === button ? showingMap : !showingMap && control.dataset.sfGridView === lastProductView));
            });
            if (showingMap) mapExplorer?.querySelector('[data-sf-map-frame]')?.contentWindow?.postMessage({type:'sofly-discovery-resize'}, 'https://account.sofly.io');
            return;
          }
          lastProductView = view;
          if (productContainer) productContainer.hidden = false;
          if (mapSection) mapSection.hidden = true;
          grid.dataset.view = view;
          const compactMode = view === 'compact';
          grid.classList.toggle('sf-list-compact', compactMode);
          if (compactMode) {
            grid.dataset.bladeComponent = 'sf-list-compact';
            grid.dataset.bladeRevision = '1.7';
          } else {
            delete grid.dataset.bladeComponent;
            delete grid.dataset.bladeRevision;
          }
          toolbar.querySelectorAll('[data-sf-grid-view]').forEach((control) => {
            control.setAttribute('aria-pressed', String(control === button));
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) init(node.matches?.('[data-sf-collection-controls]') ? node.parentElement : node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
